import axios from "@/libs/api.request";
import axios2 from "@/libs/api.request2";
import { chuku } from "./api_url";
export const get_table_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.list_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const add_table_data = data => {
  let country_code = localStorage.getItem("country_code");
   data.append("country_code", country_code);
  return axios.request(
    {
      url: chuku.add_list_data,
      data:data,
      method: "post"
    },
    "FormData"
  );
};
export const del_table_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.del_list_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const download_life = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.download_life,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_token = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_token,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const edit_platform = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.edit_platform,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_effective_router = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_effective_router,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_effective_router_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_effective_router_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_qr_code = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_qr_code,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_website_data = () => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_website_data,
    method: "post",
    data: {
      company_code: "PACEIC",
      country_code
    }
  });
};
export const download_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.download_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const del_download = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.del_download,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_device4g = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_device4g,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_left_data4g = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_left_data4g,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_4g_broken_line = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_4g_broken_line,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_danti_view = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_danti_view,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

export const sn_file_log = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.sn_file_log,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

export const get_project_listinfo = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_project_listinfo,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

export const get_import_sn_did = data => {
  let country_code = localStorage.getItem("country_code");
    data.append("country_code", country_code);
  return axios.request({
    url: chuku.get_import_sn_did,
    data:data ,
    method: "post"
  });
};

export const import_sn = data => {
  let country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: chuku.import_sn,
    data: data,
    method: "post"
  });
};
export const getinfoData = data => {
  let country_code = localStorage.getItem("country_code");
  return axios2.request({
    url: chuku.get_info_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const editinfoData = data => {
  let country_code = localStorage.getItem("country_code");
  return axios2.request({
    url: chuku.edit_info_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const get_qgl_data = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_qgl_data,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

export const get_qgl_broken_line = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: chuku.get_qgl_broken_line,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
export const dldpget = data => {
  return axios.request({
    url: '/index.php/admin/dp/web_dpget',
    data: {
      ...data,
    },
    method: "post"
  });
};
export const dldpset = data => {
  return axios.request({
    url: '/index.php/admin/dp/web_dpset',
    data: {
      ...data,
    },
    method: "post"
  });
};
//批量设置，产品型号pl_cpxh
export const pl_list = data => {
  return axios.request({
    url: chuku.pl_list,
    data: {
      ...data,
    },
    method: "post"
  });
};
//获取电柜状态
export const get_4g_data_dg = data => {
  return axios.request({
    url: '/index.php/admin/device4g/get_4g_data_dg',
    data: {
      ...data,
    },
    method: "post"
  });
};
//是否支持修改packsn
export const editPackSn = data => {
  return axios.request({
    url: '/index.php/admin/device/check_support_dp',
    data: {
      ...data,
    },
    method: "post"
  });
};
